import {createAction as createGenericAction} from 'redux-actions'

function createAction(name) {
  return createGenericAction(`INTERIM_PAGE_${name}`)
}

export const setArticleId = createAction('SET_ARTICLE_ID')
export const setCompanyId = createAction('SET_COMPANY_ID')
